module.exports = __webpack_public_path__ + "img/jbt7123_yct_v1_yct112_4a.prt.a148e007.jpg";